function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import Link from '../Link';
import { iconCaretUp, iconCaretDown } from '@wfp/icons';
import Icon from '../Icon';
import settings from '../../globals/js/settings';
var prefix = settings.prefix;

var MoreLink = function MoreLink(_ref) {
  var handleToggleClick = _ref.handleToggleClick,
      link = _ref.link,
      text = _ref.text,
      showMore = _ref.showMore;

  if (link) {
    var clonedLink = React.cloneElement(link, {
      onClick: handleToggleClick
    });
    return clonedLink;
  } else {
    return React.createElement(Link, {
      className: "".concat(prefix, "--read-more__trigger"),
      small: true,
      onClick: handleToggleClick
    }, text, React.createElement(Icon, {
      icon: showMore ? iconCaretUp : iconCaretDown,
      width: "10",
      height: "10",
      description: showMore ? 'icon up' : 'icon down'
    }));
  }
};

var ReadMore =
/*#__PURE__*/
function (_Component) {
  _inherits(ReadMore, _Component);

  function ReadMore(props) {
    var _this;

    _classCallCheck(this, ReadMore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReadMore).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleToggleClick", function (e) {
      e.preventDefault();
      var innerHeight = _this.divElement.clientHeight;

      _this.setState(function (prevState) {
        return {
          showMore: !prevState.showMore,
          innerHeight: innerHeight
        };
      });
    });

    _this.state = {
      showMore: false,
      innerHeight: 0
    };
    return _this;
  }

  _createClass(ReadMore, [{
    key: "render",
    value: function render() {
      var _classnames,
          _this2 = this;

      var _this$props = this.props,
          collapseLink = _this$props.collapseLink,
          collapseText = _this$props.collapseText,
          children = _this$props.children,
          collapsed = _this$props.collapsed,
          className = _this$props.className,
          expandLink = _this$props.expandLink,
          expandText = _this$props.expandText,
          fade = _this$props.fade,
          maxHeight = _this$props.maxHeight;
      var _this$state = this.state,
          innerHeight = _this$state.innerHeight,
          showMore = _this$state.showMore;
      var classNames = classnames(className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "--read-more"), true), _defineProperty(_classnames, "".concat(prefix, "--read-more--expanded"), showMore), _defineProperty(_classnames, "".concat(prefix, "--read-more--fade"), fade), _defineProperty(_classnames, "".concat(prefix, "--read-more--max-height"), maxHeight), _classnames));
      var contentStyle = !maxHeight ? {
        undefined: undefined
      } : maxHeight && !showMore ? {
        maxHeight: maxHeight
      } : {
        maxHeight: innerHeight + 20
      };
      var collapseStyle = showMore ? {
        display: 'none'
      } : {
        display: 'block'
      };
      return React.createElement("div", {
        className: classNames
      }, React.createElement("div", {
        className: "".concat(prefix, "--read-more__content"),
        style: contentStyle
      }, React.createElement("div", {
        ref: function ref(divElement) {
          return _this2.divElement = divElement;
        }
      }, (showMore || !collapsed) && children, collapsed && React.createElement("div", {
        style: collapseStyle
      }, collapsed))), React.createElement(MoreLink, {
        handleToggleClick: this.handleToggleClick,
        showMore: showMore,
        link: showMore ? collapseLink : expandLink,
        text: showMore ? collapseText : expandText
      }));
    }
  }]);

  return ReadMore;
}(Component);

_defineProperty(ReadMore, "propTypes", {
  /**
   * Specify an optional className to be applied to the wrapper node
   */
  className: PropTypes.string,

  /**
   * The content of the expanded element
   */
  children: PropTypes.node.isRequired,

  /**
   * The content of the collapsed content (optional)
   */
  collapsed: PropTypes.node,

  /**
   * A custom link for collapsing
   */
  collapseLink: PropTypes.node,

  /**
   * A custom link for expanding
   */
  expandLink: PropTypes.node,

  /**
   * Enables the fade effect when the content is collapsed (optional) when enabled collapsed will be ignored
   */
  fade: PropTypes.bool,

  /**
   * The maximum height when the content is collapsed (optional)
   */
  maxHeight: PropTypes.number
});

_defineProperty(ReadMore, "defaultProps", {
  expandText: 'Read more',
  collapseText: 'Read less'
});

export { ReadMore as default };